<template>
  <div class="mobile_creativity">
    <img width="100%" :src="imgUrl" alt="" />
    <p style="font-size: 20px; margin-bottom: 10px;margin-top: 40px; font-weight: 700" class="mobile_creativity_p">
      创意和技术支持
    </p>
    <p style="font-size: 12px" class="mobile_creativity_p1">
      我们的生态伙伴能力非凡，从创意构思到复杂的全案执行，全力推动虚拟制作从灵感到最终作品的高效转化。
    </p>
    <button :style="{ backgroundColor: btnColor  }" class="creativity_btn" @click="jumpTo('/CaseDemonstration#CallMe')">联系我们</button>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  props: {
    imgUrl: {
      type: String,
      default: 'https://download.hecoos.com/enlightv/2025-17/a9139c333899bf3a42f9253481f5771b.png',
    },
    btnColor: {
      type: String,
      default: () => '#2a82e4',
    },
  },
  methods: {
    jumpTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mobile_xty.scss";
</style>
